module.exports = __webpack_public_path__ + "img/timemoney_hi.04ad4023.jpg";